import {
  DataGrid,
  GridCellParams,
  GridPageChangeParams,
} from "@material-ui/data-grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router";
import { searchArtists, SEARCH_PAGE_SIZE } from "../../sdk/search";
import { ArtistIndexSchema } from "../../../../../services/search-admin/types/index-schema/artist-index-schema";
import { Chip, Input, Toolbar, Typography } from "@material-ui/core";

export const ArtistListPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState(0);
  const [artists, setArtists] = React.useState<ArtistIndexSchema[]>([]);
  const [page, setPage] = React.useState<number>(0);
  const [query, setQuery] = React.useState<string>();

  const handlePageChange = (params: GridPageChangeParams) => {
    setPage(params.page);
  };

  const handleSearch = (resetPage: boolean = true) => {
    setLoading(true);
    if (resetPage) {
      setPage(0);
    }
    searchArtists(resetPage ? 0 : page, query)
      .then((data) => {
        setArtists(data.results);
        setSize(data.total || 0);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    handleSearch(false);
  }, [page]);

  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Artists
        </Typography>
        <Input
          placeholder="Lookup artist"
          inputProps={{ "aria-label": "search" }}
          style={{ width: "500px" }}
          value={query}
          onChange={(ev) => setQuery(ev.target.value)}
          onKeyDown={(ev) => (ev.key === "Enter" ? handleSearch() : undefined)}
        />
      </Toolbar>
      <div style={{ display: "flex", height: "750px", marginTop: "20px" }}>
        <DataGrid
          rows={artists}
          columns={[
            {
              field: "name",
              headerName: "Name",
              width: 400,
              renderCell: (params) => {
                const artist = params.row as ArtistIndexSchema;
                let enabled = false;
                if (artist?.enabled === undefined || artist?.enabled === true) {
                  enabled = true;
                }
                return enabled ? (
                  <Typography>{artist?.name}</Typography>
                ) : (
                  <Typography>
                    {" "}
                    <b style={{ color: "red" }}>*</b> {artist?.name}
                  </Typography>
                );
              },
            },
            { field: "email", headerName: "Email", width: 200 },
            {
              field: "subscription",
              headerName: "Plan",
              width: 110,
              type: "object",
              valueFormatter: (params) => {
                const subscription =
                  params?.value as ArtistIndexSchema["subscription"];
                const plan = subscription?.plan
                  ? subscription.plan
                  : "Beginner";
                return `${plan}${
                  subscription?.isActive || plan === "Beginner"
                    ? ""
                    : " (INACTIVE)"
                }`;
              },
            },
            {
              field: "releases",
              headerName: "Releases",
              width: 150,
              type: "number",
              valueFormatter: (params) => {
                const releases = params?.row
                  .releases as ArtistIndexSchema["releases"];
                return releases.length;
              },
            },
            {
              field: "pending",
              headerName: "Pending",
              width: 150,
              type: "number",
              valueFormatter: (params) => {
                const releases = params?.row
                  .releases as ArtistIndexSchema["releases"];
                return releases.filter((r) => r.status === "pending").length;
              },
            },
            {
              field: "published",
              headerName: "Published",
              width: 150,
              type: "number",
              valueFormatter: (params) => {
                const releases = params?.row
                  .releases as ArtistIndexSchema["releases"];
                return releases.filter((r) => r.status === "published").length;
              },
            },
            // { field: "earnings", headerName: "Earnings", width: 150, type: 'number', valueFormatter: (params) => `$${(params.value)}` },
            // { field: "streams", headerName: "Streams", width: 150, type: 'number' },
            {
              field: "inWatchlist",
              headerName: "Watchlist",
              width: 140,
              renderCell: (params: GridCellParams) =>
                params.value ? (
                  <Chip size="small" label="WATCHLIST" color="secondary" />
                ) : (
                  <></>
                ),
            },
          ]}
          pagination
          pageSize={SEARCH_PAGE_SIZE}
          rowCount={size}
          onPageChange={handlePageChange}
          page={page}
          paginationMode="server"
          loading={loading}
          onRowClick={(params, ev) => {
            const url = `${location.pathname}/${params.row.id}`;
            if (ev.ctrlKey || ev.metaKey) {
              window.open(url, '_blank')
            } else {
              history.push(url, location.state)
            }
          }}
        />
      </div>
    </section>
  );
};
